export const truncateText = (text: string | undefined, maxLength: number): string | null => {
  if (text) {
    if (text.length > maxLength) {
      return `${text.substring(0, maxLength)}...`;
    }
    return text;
  }
  return null;
};
